import { loadDIModules, useInject } from '@actr/di';
import { IBaseComponentProps } from '@actr/specs/src/base-component-props';
import seoBannersDIModule from '@actr/stores/src/modules/seo/banners';
import { CmsBannersService } from '@actr/stores/src/services/services/seo/banners';
import { CmsBannersListItem } from '@actr/stores/src/stores/models/seo/banners';
import { Carousel } from '@actr/ui/src/components/carousel';
import { SlideImgObjectFit } from '@actr/ui/src/components/carousel/specs';
import { DecodeImageQuality, getDecodeImage } from '@actr/utilities/src/url/decode-image';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';

import * as Styled from './style.css';

export interface MainPageBannersProps extends IBaseComponentProps {
  items: CmsBannersListItem[];
  /** endpoint сброса кэша страницы, если баннеры из SSR устарели */
  revalidateUrl: string;
  onBannerClick?: () => void;
}

const MainPageBanners: FC<MainPageBannersProps> = observer(props => {
  const {
    className,
    items,
    revalidateUrl,
    onBannerClick
  } = props;

  const cmsBannersService = useInject(CmsBannersService);

  useEffect(() => {
    cmsBannersService.getBannersList()
      .then(data => {
        if (data) {
          if (!(data.length === items?.length && data.every(elem => items?.some(o => o.id === elem.id)))) {
            fetch(revalidateUrl);
          }
        }
      });
  }, []);

  function clickBannerItem(bannerLink: string) {
    onBannerClick?.();
    window.open(bannerLink, '_blank');
  }

  const carouselItems = () => items.map(banner => ({
    image: getDecodeImage(banner.mobile_image, DecodeImageQuality.Q80),
    alt: banner.title,
    onAction: () => clickBannerItem(banner.external_link)
  }));

  return (
    <Carousel
      className={classNames(Styled.BannerCarousel, className)}
      items={carouselItems()}
      imgObjectFit={SlideImgObjectFit.NONE}
      withBorder={false}
      slidesPerViewBreakPoints={{
        800: {
          slidesPerView: 2,
        },
        1100: {
          slidesPerView: 3,
        }
      }}
    />
  );
});

export default loadDIModules(MainPageBanners, seoBannersDIModule) as React.FC<MainPageBannersProps>;
